import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/back/api';

export interface Member {
    id: string;
    login: string;
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    role: string;
    created_at: string;
}

export const adminService = {
    getMembers: async (token: string): Promise<{ members: Member[] }> => {
        const response = await axios.get(`${API_URL}/admin/members.php`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    deleteMember: async (token: string, id: string) => {
        const response = await axios.delete(`${API_URL}/admin/members.php`, {
            headers: { Authorization: `Bearer ${token}` },
            data: { id }
        });
        return response.data;
    },

    updateRole: async (token: string, id: string, role: string) => {
        const response = await axios.put(`${API_URL}/admin/update_role.php`, { id, role }, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    }
};
